import { TaggedSlugEntityPublicApiService } from './taggedSlugEntityPublicApiService';
import { SuccessStory } from '@models/successStory';

export class SuccessStoryPublicService extends TaggedSlugEntityPublicApiService<SuccessStory> {
    constructor() {
        super('/api/success-story');
    }
}
